import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import MobileScreen from 'mobile/components/MobileScreen'

import SearchField from './SearchField'

const OrderPad = () => {
  return (
    <MobileScreen
      title="Fast Customer"
      titleIcon="account_circle"
      speedDialActions={[]}
      CollapsableSearchComponent={SearchField}
    >
      <Skeleton animation="wave" variant="rect" width="100%" height="250" />
      <Skeleton animation="wave" variant="rect" width="100%" height="250" />
    </MobileScreen>
  )
}

export default OrderPad
